const OfferBar = () => {
  return (
    <div className="offer-bar">
      <div className="offer-track">
        <span>🎉 FREE Eye Check-Up for Limited Time</span>
        <span>👓 Flat Discounts on Spectacles</span>
        <span>⌚ New Watch Collections Available</span>
        <span>📍 Visit Our Store in Masrakh Today</span>

        {/* duplicate for smooth loop */}
        <span>🎉 FREE Eye Check-Up for Limited Time</span>
        <span>👓 Flat Discounts on Spectacles</span>
        <span>⌚ New Watch Collections Available</span>
        <span>📍 Visit Our Store in Masrakh Today</span>
      </div>
    </div>
  );
};

export default OfferBar;
